var _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDrawer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    enableBackground: "new 0 0 35 35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "palette",
    display: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "artboards_-_bkgds"
  }), /*#__PURE__*/React.createElement("g", {
    id: "page_contents"
  }), /*#__PURE__*/React.createElement("g", {
    id: "header__x2F__nav"
  }), /*#__PURE__*/React.createElement("g", {
    id: "overlay"
  }), /*#__PURE__*/React.createElement("g", {
    id: "map"
  }), /*#__PURE__*/React.createElement("g", {
    id: "extras",
    display: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "annotation"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#C9920E",
    cx: 17.477,
    cy: 17.432,
    r: 15.918
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.498,0C7.835,0,0,7.835,0,17.5S7.835,35,17.498,35C27.165,35,35,27.165,35,17.5S27.165,0,17.498,0z                         M25.677,22.306h-5.161h-4.739H9c-0.367-0.365-0.367-0.959,0-1.327l7.979-10.61c0.369-0.371,0.965-0.371,1.334,0.001                         l7.365,10.608C26.043,21.347,26.043,21.94,25.677,22.306z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDrawer);
export default __webpack_public_path__ + "static/media/ico-drawer.e5ff87b0.svg";
export { ForwardRef as ReactComponent };